(function () {
  function initElfsightLoader() {
    const wrappers = document.querySelectorAll(".elfsight-review-wrapper");

    if (!wrappers.length) {
      return;
    }

    wrappers.forEach(function (wrapper) {
      const loader = wrapper.querySelector(".elfsight-loader");
      const widget = wrapper.querySelector(".elfsight-widget");

      if (!loader || !widget) {
        return;
      }

      let fallbackTimer;

      const hideLoader = function () {
        loader.classList.add("is-hidden");

        observer.disconnect();

        if (fallbackTimer) {
          clearTimeout(fallbackTimer);
        }
      };

      const checkWidgetLoaded = function () {
        const elfsightContent = widget.querySelector(
          "iframe, [class*='elfsight'], [class*='eapps']",
        );

        if (elfsightContent) {
          hideLoader();
        }
      };

      const observer = new MutationObserver(checkWidgetLoaded);

      observer.observe(widget, {
        childList: true,
        subtree: true,
      });

      // Check immediately in case Elfsight is already loaded.
      checkWidgetLoaded();

      // Fallback: prevent the loader from staying forever.
      fallbackTimer = setTimeout(function () {
        hideLoader();
      }, 10000);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initElfsightLoader, {
      once: true,
    });
  } else {
    initElfsightLoader();
  }
})();
